import { render, staticRenderFns } from "./userdropdown.vue?vue&type=template&id=2df7a470&"
import script from "./userdropdown.vue?vue&type=script&lang=js&"
export * from "./userdropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports